import { FC, ReactNode } from "react";
import { useIsModuleConnected } from "../utils/use-is-module-connected";
import { HR } from "../constants/modules-id";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

export function HrModuleOr404({ children }: { children: ReactNode }) {
  const moduleConnected = useIsModuleConnected(HR);

  if (moduleConnected) {
    return children;
  }

  return <ToPageNotFound />;
}

export function WithHrModuleOr404<T extends object>(Component: FC<T>) {
  function HrModuleOrRedirectComponent(props: T) {
    return (
      <HrModuleOr404>
        <Component {...props} />
      </HrModuleOr404>
    );
  }

  return HrModuleOrRedirectComponent;
}
